import React, { useState, useEffect } from 'react';
import { Button } from '../components/Button';
import { SelectField, TextField } from '../components/Fields';
import { AuthLayout } from '../components/AuthLayout';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import {
  accountNumberLooksLikeVerificationCode,
  getAccountNumberMisentryMessage,
  getValidatedVerificationCode,
} from '../utils/verificationCode';
import { getAuthHeaders, getAccessToken, getRefreshToken, handleAuthError, requireAccessToken } from '../utils/auth';

function NewSSNumberForm() {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const [newTradingLoading, setNewTradingLoading] = useState(false);
	const [newTradingMessage, setNewTradingMessage] = useState('');
	const [accountNumberError, setAccountNumberError] = useState('');
	const [agreed, setAgreed] = useState(false);
	
	// Get action from URL parameters
	const action = searchParams.get('action') || '';
	
	const [formData, setFormData] = useState({
		old: '',
		account_number: '',
		pass: '',
		ipass: '',
		vcode: '',
		server: 'Deriv-Demo'
	});
	
	// If no valid synthetic action, redirect back to action selection
	useEffect(() => {
		if (action !== 'add_ss' && action !== 'add_ss_lite' && action !== 'ssi' && action !== 'add_aso_ss') {
			navigate('/selfservice/synthetic');
		}
	}, [action, navigate]);

	useEffect(() => {
		const validatedCode = getValidatedVerificationCode();
		if (validatedCode) {
			setFormData(prev => ({ ...prev, vcode: validatedCode }));
		}
	}, []);

	const getVerificationCodesToCheck = (vcode) =>
		[vcode, getValidatedVerificationCode()].filter(Boolean);

	const updateAccountNumberError = (accountNumber, vcode) => {
		const isWrongValue = getVerificationCodesToCheck(vcode).some(code =>
			accountNumberLooksLikeVerificationCode(accountNumber, code)
		);
		setAccountNumberError(
			isWrongValue ? getAccountNumberMisentryMessage(action) : ''
		);
		return isWrongValue;
	};

	const handleAccountNumberChange = (e) => {
		const value = e.target.value.replace(/[^0-9]/g, '');
		setFormData(prev => {
			updateAccountNumberError(value, prev.vcode);
			return { ...prev, account_number: value };
		});
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		if (!requireAccessToken()) return;
		setNewTradingLoading(true);
		
		// Validation
		// if (formData.ipass === '') {
		// 	setNewTradingMessage('Investor password is required');
		// 	setNewTradingLoading(false);
		// 	return;
		// }
		if (formData.pass === '') {
			setNewTradingMessage('Password is required');
			setNewTradingLoading(false);
			return;
		}
		if (formData.account_number === '') {
			setNewTradingMessage('Account number is required');
			setNewTradingLoading(false);
			return;
		}
		if (updateAccountNumberError(formData.account_number, formData.vcode)) {
			setNewTradingLoading(false);
			return;
		}
		if (formData.vcode === '') {
			setNewTradingMessage('Verification code is required');
			setNewTradingLoading(false);
			return;
		}

		if (action === 'add_ss' || action === 'add_aso_ss') {
			axios.post(
				`https://maindashbe-june-b18731a0e161.herokuapp.com/selfservice/${action === 'add_aso_ss' ? 'add-synthetic-signals-aso' : 'add-synthetic-signals'}/`,
				action === 'add_aso_ss'
					? {
							new_account_number: formData.account_number,
							old_account_number: formData.old,
							password: formData.pass,
							investor_password: formData.ipass,
							verification_code: formData.vcode,
							server: 'Deriv-Demo'
					  }
					: {
							account_number: formData.account_number,
							password: formData.pass,
							investor_password: formData.pass,
							verification_code: formData.vcode,
							server: 'Deriv-Demo'
					  },
				{
					headers: getAuthHeaders()
				}
			)
				.then(res => {
					if (res.data.message) {
						setNewTradingMessage(res.data.message);
					}
					setNewTradingLoading(false);
					if (res.data.message !== 'Account number is required' && 
						res.data.message !== 'Account already has an ASO account' && 
						res.data.message !== 'Account type not supported' && 
						res.data.message !== 'Old account already has a new account' && 
						res.data.message !== 'Invalid verification code' && 
						res.data.message !== 'You have an active Aso account already.' && 
						res.data.message !== 'Verification code is required' && 
						res.data.message !== 'Invalid verification code or code already used') {
						window.location.href = process.env.REACT_APP_PUBLIC_ENVIRONMENT === 'PRODUCTION' 
							? `https://dashboard.ft9ja.com/dashboards?token=${getAccessToken()}&refresh_token=${getRefreshToken()}` 
							: `https://ft9ja-completion-v1-dashboard.netlify.app/dashboards?token=${getAccessToken()}&refresh_token=${getRefreshToken()}`;
					}
				})
				.catch(err => {
					if (handleAuthError(err)) return;
					if (err.response?.status === 500) {
						setNewTradingMessage('Server error, please contact support');
					}
					setNewTradingLoading(false);
				});
		} else {
			const endpoint = action === 'ssi' ? 'add-synthetic-signals-instant' : 'add-synthetic-signals-lite';
			axios.post(
				`https://maindashbe-june-b18731a0e161.herokuapp.com/selfservice/${endpoint}/`,
				{
					account_number: formData.account_number,
					password: formData.pass,
					investor_password: formData.pass,
					verification_code: formData.vcode,
					server: 'Deriv-Demo'
				},
				{
					headers: getAuthHeaders()
				}
			)
				.then(res => {
					if (res.data.message) {
						setNewTradingMessage(res.data.message);
					}
					setNewTradingLoading(false);
					if (res.data.message !== 'Account number is required' && 
						res.data.message !== 'Account already has an ASO account' && 
						res.data.message !== 'Account type not supported' && 
						res.data.message !== 'Old account already has a new account' && 
						res.data.message !== 'Invalid verification code' && 
						res.data.message !== 'You have an active Aso account already.' && 
						res.data.message !== 'Verification code is required' && 
						res.data.message !== 'Invalid verification code or code already used') {
						window.location.href = process.env.REACT_APP_PUBLIC_ENVIRONMENT === 'PRODUCTION' 
							? `https://dashboard.ft9ja.com/dashboards?token=${getAccessToken()}&refresh_token=${getRefreshToken()}` 
							: `https://ft9ja-completion-v1-dashboard.netlify.app/dashboards?token=${getAccessToken()}&refresh_token=${getRefreshToken()}`;
					}
				})
				.catch(err => {
					if (handleAuthError(err)) return;
					if (err.response?.status === 500) {
						setNewTradingMessage('Server error, please contact support');
					}
					setNewTradingLoading(false);
				});
		}
	};

	const getTitle = () => {
		if (action === 'add_ss') return 'Add Synthetic Signal Account';
		if (action === 'add_ss_lite') return 'Add Synthetic Signal Lite Account';
		if (action === 'ssi') return 'Add Synthetic Signals Instant Account';
		if (action === 'add_aso_ss') return 'Add Aso for Synthetic Signal Account';
		return 'Add Synthetic Signal Account';
	};

	// Don't render if action is invalid (should redirect)
	if (action === null) {
		return null;
	}

	return (
		<AuthLayout>
			<form onSubmit={handleSubmit}>
				<div className="grid grid-cols-1 gap-6">
					<h1 className="text-center font-medium text-[1.3rem]">{getTitle()}</h1>
					{action === 'add_aso_ss' && (
						<TextField
							label="Old Account number"
							id="old_account_number"
							name="old_account_number"
							type="name"
							value={formData.old || ''}
							onChange={e => setFormData(prev => ({ ...prev, old: e.target.value.replace(/[^0-9]/g, '') }))}
							autoComplete="given-name"
							required
						/>
					)}
					<div>
						<TextField
							label={action === 'add_aso_ss' ? 'New Account number' : 'MT5 Trading Account Number'}
							id="account_number"
							name="account_number"
							type="name"
							value={formData.account_number || ''}
							onChange={handleAccountNumberChange}
							autoComplete="given-name"
							required
						/>
						{accountNumberError && (
							<p className="mt-2 text-sm text-red-500">{accountNumberError}</p>
						)}
					</div>
					<TextField
						className="col-span-full"
						label="MT5 Trading Password"
						id="trading_password"
						name="trading_password"
						type="password"
						value={formData.pass || ''}
						onChange={e => setFormData(prev => ({ ...prev, pass: e.target.value }))}
						autoComplete="trading_password"
						required
					/>
					{/* <TextField
						className="col-span-full"
						label="Investor Password"
						id="investor_password"
						name="investor_password"
						type="password"
						value={formData.ipass || ''}
						onChange={e => setFormData(prev => ({ ...prev, ipass: e.target.value }))}
						autoComplete="investor_password"
						required
					/> */}
					<TextField
						className="col-span-full"
						label={action === 'add_ss' || action === 'add_ss_lite' || action === 'ssi' ? 'FT9ja Account Setup Code' : 'Verification Code'}
						id="verification_code"
						name="verification_code"
						type="text"
						value={formData.vcode || ''}
						onChange={e => {
							const value = e.target.value;
							setFormData(prev => {
								updateAccountNumberError(prev.account_number, value);
								return { ...prev, vcode: value };
							});
						}}
						autoComplete="verification_code"
						required
					/>
					<SelectField
						className="col-span-full"
						label="Server"
						id="server"
						name="server"
						value={formData.server || 'Deriv-Demo'}
						onChange={e => setFormData(prev => ({ ...prev, server: e.target.value }))}
					>
						<option value="Deriv-Demo">Deriv-Demo</option>
					</SelectField>
					<TextField
						className="col-span-full"
						label="Platform"
						id="platform"
						name="platform"
						type="text"
						value="MT5"
						readOnly
						autoComplete="platform"
						required
					/>
				</div>
				<p className="text-center text-red-500 mb-5">{newTradingMessage}</p>
				<div>
					<p>Tampering with the account details (login, password, leverage, topping up the balance) without written approval from FT9ja violates the rule.</p>
					<div className="flex items-center gap-2 mt-5">
						<input type="checkbox" onChange={() => setAgreed(!agreed)} checked={agreed} />
						<p>I have read and agreed with the rules and terms</p>
					</div>
				</div>
				{agreed && (
					<Button type="submit" color="cyan" className="mt-8 w-full duration-200 hover:bg-gray-800 focus:bg-[#28a745] focus:text-white/80">
						{newTradingLoading ? 'Please Wait...' : 'Submit'}
					</Button>
				)}
			</form>
		</AuthLayout>
	);
}

export default NewSSNumberForm;

